export enum TypeAwardEnum {
  AchievementWithMaterialPrizes = 'AchievementWithMaterialPrizes',
  AchievementWithPromoCodes = 'AchievementWithPromoCodes',
  AchievementWithUnlimitedNumberOfPrizes = 'AchievementWithUnlimitedNumberOfPrizes',
}
